import React from "react";
import { View } from "react-native";

import { Icon } from "components";

import { styles } from "./styles";

export const IconQuestion = props => {
  const { question, selectedOptions, selectOption, lang } = props;
  return (
    <View style={styles.container}>
      {question.options.map(option => {
        const iconProps = {
          text: option[lang],
          isSelected: selectedOptions[option.virtual_id],
          image: option.image,
          onPress: () => selectOption(question, option),
        };
        return <Icon key={option.virtual_id} {...iconProps} />;
      })}
    </View>
  );
};
